import { z } from 'zod';
import { mealSlotSchema } from './planning.js';
/* ==========================================================================
 *  Rhythm-slot learning contract (ADR-0035 / T32.2 — mobile revamp)
 *
 *  GET /me/rhythm reads the learned pattern (confidence included — the field
 *  ADR-0035 §6 deliberately keeps off the locked `dayFeedSlotItemSchema`).
 *  PATCH /me/rhythm flips the `profile.rhythm_enabled` flag.
 * ========================================================================== */
/** Tuning knobs (ADR-0035 §1) — one visible swappable object, the
 *  ALERT_THRESHOLDS precedent (ADR-0009 §3), so tuning never means hunting
 *  through the service. */
export const RHYTHM_THRESHOLDS = {
    /** Trailing days of history considered. */
    windowDays: 14,
    /** Distinct logging days a band needs to become a slot. */
    minPatternDays: 5,
    /** Max IQR (minutes) of a band's log times before it's too scattered. */
    maxSpreadMin: 180,
    /** How long past usualTime a slot stays an invitation. */
    slotGraceMin: 90,
    /** roomKcal rounds to the nearest multiple of this. */
    roomRoundingKcal: 25,
    /** Below this apportioned share, roomKcal = null (too small to show). */
    roomFloorKcal: 50,
};
export const rhythmPatternItemSchema = z.object({
    mealSlot: mealSlotSchema,
    /** "HH:MM", median of the band's log times (ADR-0035 §1 step 5). */
    usualTime: z.string().regex(/^\d{2}:\d{2}$/),
    /** distinctDays / windowDays, clamped [0,1]. Coverage only — not a
     *  visibility gate beyond the pattern threshold (ADR-0035 §1 step 6). */
    confidence: z.number().min(0).max(1),
});
export const rhythmSettingsResponseSchema = z.object({
    /** Effective value: profile.rhythm_enabled ?? true (NULL = default on). */
    enabled: z.boolean(),
    slots: z.array(rhythmPatternItemSchema),
});
export const rhythmPatchSchema = z.object({
    enabled: z.boolean(),
});
//# sourceMappingURL=rhythm.js.map